<div
  *ngIf="loading"
  class="loader flex flex-column justify-content-center align-items-center gap-6">
  <img
    class="w-auto h-5rem"
    [src]="'/assets/media/logo/paymefy-logo-dark.png'" />
  <span class="loader-spinner"></span>
</div>
